var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "treeTable" },
    [
      _vm._t("header"),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "table",
        },
        [
          _c(
            "vxe-table",
            {
              ref: "xTable",
              attrs: {
                border: "",
                height: "390px",
                "show-header-overflow": "",
                "show-overflow": "",
                "highlight-hover-row": "",
                data: _vm.data,
              },
              on: {
                "checkbox-change": _vm.changeBox,
                "checkbox-all": _vm.changeAll,
              },
            },
            [
              _c("vxe-table-column", {
                attrs: { type: "checkbox", width: "40", fixed: "left" },
              }),
              _vm._l(_vm.columns, function (col, index) {
                return _c("vxe-table-column", {
                  key: index,
                  staticStyle: { height: "36px" },
                  attrs: {
                    field: col.field,
                    title: col.title,
                    "min-width": col.width ? col.width : 80,
                    fixed: col.fixed,
                    "header-class-name": "header-col",
                  },
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm.total > 0
        ? _c(
            "div",
            { staticClass: "page" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageConfig.pageNum,
                  "page-size": _vm.pageConfig.pageSize,
                  layout: "prev, pager, next, jumper",
                  "pager-count": 5,
                  total: _vm.total,
                },
                on: {
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.pageConfig, "pageNum", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.pageConfig, "pageNum", $event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }